import axios from 'axios';
import { requireLocalBackendUrl } from './localBackend';

// TCA-26101907: preserve legacy data returns while an owned caller captures the
// response's cache identity. This metadata is never sent as a request payload.
export const reviewLocalBase = config => config?.reviewLocalBase || requireLocalBackendUrl();

export async function reviewRequest(method, url, data, config) {
  const { reviewResponse, reviewLocalBase: _local, ...requestConfig } = config || {};
  const options = config ? [requestConfig] : [];
  if (method === 'delete' && data !== undefined) {
    const response = await axios.delete(url, { ...requestConfig, data });
    reviewResponse?.(response);
    return response.data;
  }
  const response = ['get', 'delete'].includes(method)
    ? await axios[method](url, ...options)
    : await axios[method](url, ...(config || data !== undefined ? [data, ...options] : []));
  reviewResponse?.(response);
  return response.data;
}
